import * as React from "react";
import * as ReactDOM from "react-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { SearchResultLoader } from "../../Utils/SearchResultLoader";
import { GetDocumentById } from "../../Utils/ProstewardAPI";
import { Pdfdocviewer } from "../PDFViewer/Pdfdocviewer";
import "./resultgridStyle.css";
import Erorrnotification from "../ErrorNotifications/Notifications";
import { SetSessionItem, GetSessionItem } from '../../Utils/Cache.js'
import { useTranslation } from "react-i18next";

const ResultsGrid = (formprops) => {
  const [products, setProducts] = React.useState({
    data: [],
    total: 0,
  });
  const initialdataState = {
    take: 20,
    skip: 0,
  }
  const [dataState, setDataState] = React.useState(initialdataState);
  const [currentPdf, setCurrentPdf] = React.useState('');
  const { t } = useTranslation();
  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };
  const dataReceived = (products) => {
    if (products.data) {
      setshowPDF(false);
      setProducts(products);
    } else {
      setProducts({
        data: [],
        total: 0,
      });
    }
    setCurrentPdf("")
    VerifyIfNewRequest();
  };

  const VerifyIfNewRequest = () =>{
    if(GetSessionItem("isNewRequest") === 'true')
    {
      SetSessionItem("isNewRequest", 'false')
      setDataState(initialdataState)
    }
  }

  const pdfRef = React.useRef();
  const [errors, setErrors] = React.useState({isError: false, errormsg:""})
  const clearErrors = ()=>{
    setErrors({isError:false, errormsg:""});
  }

  const getReportCategory = (dataItem) => {
    switch(dataItem.DOCUMENTTYPE) {
      case "AIS":
        return "Article Information Sheet";
        break;
      case "DGW":
        return "Dangerous Goods Worksheet";
        break;
      case "PRDVEND":
      case "MSDS":
      case "SDS":
      default:
        return "Safety Data Sheet";
        break;
    }
  }

  const retrievePdf = async (dataItem) => {
      pdfRef.current.scrollIntoView({behavior: 'smooth'});
      if(showPDF)
        setCurrentPdf("")
      else
      {
        setshowPDF(true)
      }
      await GetDocumentById(dataItem.DOCUMENTDATAID, "PDF")
        .then((res) => {
          if (res.data.Success) {
            setshowPDF(true);
            setCurrentPdf(res.data.DocumentData);
            clearErrors();             
          }
        })
        .catch((err) => {
           setshowPDF(false);
           setErrors({isError:true, errormsg: err.message +". "+err.response?.data})
           setCurrentPdf("")
        })
  }

    const closeSVG = (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
      >
      <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59 5.59-5.59z" />
      <path d="M0 0h24v24h-24z" fill="none" />
    </svg>
  );
  const [showPDF, setshowPDF] = React.useState(false);
  const [btnMessage, setBtnMessage] = React.useState(closeSVG);
  const Closebutton = () => {
    return (
      <div className="pdfclosebutton-container">
        <button
          className="pdfclosebutton"
          onMouseEnter={() => {
            setBtnMessage("Close PDF");
          }}
          onMouseLeave={() => {
            setBtnMessage(closeSVG);
          }}
          onClick={() => {
            setshowPDF(false);
            setBtnMessage(closeSVG);
            setCurrentPdf("")
          }}
        >
          {btnMessage}
        </button>
      </div>
    );
  };
  return (
    <div>
      <Grid
        sortable={true}
        pageable={true}
        data={products}
        {...dataState}
        onDataStateChange={dataStateChange}
        dataItemKey={"DOCUMENTDATAID"}
        selectedField={"selected"}
        selectable={{
          enabled: true,
          cell: true,
          mode: "single",
        }}
        onRowClick={( async(e) => await retrievePdf(e.dataItem))}
      >
        <Column 
          width={40}
          cell={(props) => (
            <td className="cellstyle">
              <span className="k-icon k-font-icon k-i-pdf k-icon-xl altlinkstyle" onClick={(async(e) => await retrievePdf(props.dataItem))}></span>
            </td>
          )}
        />
        <Column
          width={160}
          field="DisplayProductCode"
          title={t('GridHeaders.CatalogNumber')}
          cell={(props) => (
            // <button onClick={()=> {setshowPDF(true)}} style={{width:'100%', textDecoration:'Link'}}> <td>{props.dataItem.ProductID}</td> </button>
            <td 
              className="cellstyle"
            >
              {props.dataItem.DisplayProductCode}
            </td>
          )}
        />
        <Column
          field="TRADENAME"
          title={t('GridHeaders.Document Name')}
          cell={(props) => (
            <td 
              className="cellstyle"
            >
              <span className="linkstyle" onClick={(async(e) => await retrievePdf(props.dataItem))}>{props.dataItem.TRADENAME}</span>
            </td>
          )}
        />
        <Column
           width={100}
           title={t('GridHeaders.Document Revision Number')}
           cell={(props) => (
            <td className="cellstyle">
              {parseFloat(props.dataItem.REVISIONNUM).toFixed(2)}
            </td>
           )}
        />
        <Column
          width={120}
          title={t('GridHeaders.Language')}
          cell={(props) => (
            <td 
              className="cellstyle"
            >
              {props.dataItem.DOCUMENTLANGUAGENAME}
            </td>
          )}
        />
        <Column 
          width={150}
          title={t('GridHeaders.Report Category')}
          cell={(props) => (
            <td className="cellstyle">
              {getReportCategory(props.dataItem)}
            </td>
          )}
        />
        <Column
          width={200}
          title={t('GridHeaders.Country')}
          cell={(props) => (
            <td className="cellstyle">
              {props.dataItem.COUNTRYNAME}
            </td>
          )}
        />
      </Grid>

      <SearchResultLoader dataState={dataState} searchCriteria={formprops.searchCriteria} onDataReceived={dataReceived} />

      <div ref={pdfRef} id="Pdfviewer" style={{ marginTop: "50px", width: "100%" }}>
        {showPDF && <Closebutton />}
        {showPDF && <Pdfdocviewer documentData={currentPdf} />}
      </div>
      {errors.isError && <Erorrnotification closeButton={true} errors={errors.errormsg} type="error" onErrorCompletion={clearErrors}/>}
    </div>
  );
};
      /* <ProductsLoader dataState={dataState} onDataReceived={dataReceived} /> */
      /* <SearchResultLoader dataState={dataState} onDataReceived={dataReceived} /> */
export default ResultsGrid;
